import One from './One';
import Two from './Two';
import Three from './Three';
import Four from './Four';

export const StepOne = One;
export const StepTwo = Two;
export const StepThree = Three;
export const StepFour = Four;
